import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "setting"
};
const _hoisted_2 = {
  class: "main-wrap setting-wrap"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "通用设置", -1);
const _hoisted_4 = {
  class: "card setting-card"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "代叫设置", -1);
const _hoisted_6 = {
  class: "card setting-card"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_nav_bar = _resolveComponent("nav-bar");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_switch = _resolveComponent("van-switch");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_nav_bar, {
    title: $setup.title
  }, null, 8, ["title"]), _createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_cell, {
    title: "账号和个人信息",
    "is-link": "",
    label: "管理账号的信息和个人信息",
    onClick: $options.goProfile
  }, null, 8, ["onClick"]), _createVNode(_component_van_cell, {
    title: "乘车偏好",
    "is-link": "",
    label: "设置你在叫车时的偏好",
    onClick: $options.goRidePreference
  }, null, 8, ["onClick"]), _createVNode(_component_van_cell, {
    title: "首页弹窗",
    label: "开启后将在首页弹出优惠活动或者营销信息"
  }, {
    "right-icon": _withCtx(() => [_createVNode(_component_van_switch, {
      modelValue: $setup.setting.isHomePopup,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.setting.isHomePopup = $event),
      size: "16px",
      "active-color": "#f5a029"
    }, null, 8, ["modelValue"])]),
    _: 1
  }), _createVNode(_component_van_cell, {
    title: "记录搜索历史"
  }, {
    "right-icon": _withCtx(() => [_createVNode(_component_van_switch, {
      modelValue: $setup.setting.isRecordSearch,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.setting.isRecordSearch = $event),
      size: "16px",
      "active-color": "#f5a029"
    }, null, 8, ["modelValue"])]),
    _: 1
  }), _createVNode(_component_van_cell, {
    title: "清除缓存",
    clickable: true,
    label: "清除缓存会清除运行中的临时数据",
    onClick: $options.clearCacheClick
  }, null, 8, ["onClick"])]), _hoisted_5, _createElementVNode("div", _hoisted_6, [_createVNode(_component_van_cell, {
    title: "禁止任何人为我叫车",
    label: "开启后他人将不能为你叫车"
  }, {
    "right-icon": _withCtx(() => [_createVNode(_component_van_switch, {
      modelValue: $setup.setting.isProhibitProxy,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.setting.isProhibitProxy = $event),
      size: "16px",
      "active-color": "#f5a029",
      onClick: $options.prohibitProxyClick
    }, null, 8, ["modelValue", "onClick"])]),
    _: 1
  }), _createVNode(_component_van_cell, {
    title: "禁止黑名单",
    label: "单独添加不能为你叫车的手机号码",
    "is-link": ""
  })])])]);
}